export const generateRandomId = () => {
    const randomNumber = Math.random() * 100;
    return randomNumber.toFixed(10);
};

export function addTrailingZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
}